import { use as i18nUse } from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import enUS from './locales/en-US/app.json'

function setupI18N(language, language_path) {
  if (language && language_path) {
    console.log(`Using language: ${language}`)
    i18nUse(Backend)
      .use(initReactI18next)
      .init({
        lng: language,
        fallbackLng: 'en-US',
        ns: ['app'],
        defaultNS: 'app',
        load: 'currentOnly',
        keySeparator: false,
        backend: {
          crossDomain: true,
          loadPath: language_path,
        },
        interpolation: { escapeValue: false },
      })
  } else {
    console.log('Using default language')
    i18nUse(initReactI18next).init({
      lng: 'en-US',
      supportedLngs: ['en-US'],
      fallbackLng: 'en-US',
      load: 'currentOnly',
      keySeparator: false,
      resources: {
        'en-US': { translation: enUS },
      },
      interpolation: { escapeValue: false },
    })
  }
}

export { setupI18N }
